'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002etypes$0024$002dCredential$002dHash$0024$0024anon$002443 from "./presto.types$-Credential-Hash$$anon$43.js";
var $p;
/** @constructor */
function $c_Lpresto_types$CredentialHash$() {
  this.c3R = null;
  this.c3S = false;
  this.c3P = null;
  this.c3Q = false;
  this.c3T = null;
  this.c3U = false;
  this.c3V = null;
  this.c3W = false;
}
export { $c_Lpresto_types$CredentialHash$ as $c_Lpresto_types$CredentialHash$ };
$p = $c_Lpresto_types$CredentialHash$.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_types$CredentialHash$;
/** @constructor */
function $h_Lpresto_types$CredentialHash$() {
}
export { $h_Lpresto_types$CredentialHash$ as $h_Lpresto_types$CredentialHash$ };
$h_Lpresto_types$CredentialHash$.prototype = $p;
$p.gI = (function() {
  if ((!this.c3S)) {
    this.c3R = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Encoder$().aC;
    this.c3S = true;
  }
  return this.c3R;
});
$p.ep = (function() {
  if ((!this.c3Q)) {
    this.c3P = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$().a8;
    this.c3Q = true;
  }
  return this.c3P;
});
$p.cI7 = (function() {
  if ((!this.c3U)) {
    this.c3T = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lcom_raquo_laminar_modifiers_RenderableText$$anon$1(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((x) => x)), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lcom_raquo_laminar_modifiers_RenderableText$());
    this.c3U = true;
  }
  return this.c3T;
});
$p.adu = (function() {
  if ((!this.c3W)) {
    this.c3V = new $j_presto$002etypes$0024$002dCredential$002dHash$0024$0024anon$002443.$c_Lpresto_types$CredentialHash$$anon$43(this);
    this.c3W = true;
  }
  return this.c3V;
});
var $d_Lpresto_types$CredentialHash$ = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_types$CredentialHash$, "presto.types$CredentialHash$", ({
  Za: 1,
  D: 1
}));
export { $d_Lpresto_types$CredentialHash$ as $d_Lpresto_types$CredentialHash$ };
var $n_Lpresto_types$CredentialHash$;
function $m_Lpresto_types$CredentialHash$() {
  if ((!$n_Lpresto_types$CredentialHash$)) {
    $n_Lpresto_types$CredentialHash$ = new $c_Lpresto_types$CredentialHash$();
  }
  return $n_Lpresto_types$CredentialHash$;
}
export { $m_Lpresto_types$CredentialHash$ as $m_Lpresto_types$CredentialHash$ };
//# sourceMappingURL=presto.types$-Credential-Hash$.js.map
